import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { HelperText01 } from 'components/styles';
import { useProjectDetail } from 'data/projects';
import { useIsNativeUser } from 'hooks/use-user-type';
import { EmptyParagraph } from '../../../style';

const Text = styled.p`
  ${HelperText01};
  height: var(--spacing-06);
  margin-bottom: var(--spacing-03);
`;

const Content = styled.h5`
  height: var(--spacing-06);
  align-items: center;
  display: flex;
`;

export const ProjectOverviewHighlightTileDates: FC<{ projectId: number }> = ({
  projectId,
}) => {
  const isNativeUser = useIsNativeUser();
  const { data: project } = useProjectDetail(ProjectId(projectId));
  const hasBothDates = project?.startDate && project?.dueDate;
  const hasAtleastOneDate = project?.startDate || project?.dueDate;

  return (
    <>
      <Text>
        <FormattedMessage id="project_dates" />
      </Text>
      {project && hasAtleastOneDate ? (
        <Content>
          {project.startDate && (
            <HumanisedDate timestamp={moment(project.startDate)} />
          )}
          {hasBothDates && ' - '}
          {project.dueDate && (
            <HumanisedDate timestamp={moment(project.dueDate)} />
          )}
        </Content>
      ) : (
        <EmptyParagraph>
          {isNativeUser ? (
            <>
              <FormattedMessage id="project.overview.dates.empty" />
              <Link
                to={`/projects/${projectId}/settings/`}
                data-cy="set-project-date-cta"
              >
                <FormattedMessage id="project.overview.dates.empty.cta" />
              </Link>
            </>
          ) : (
            <>-</>
          )}
        </EmptyParagraph>
      )}
    </>
  );
};
